import { Checkbox } from '@/components/react/ui/checkbox';
import { useFieldContext } from '@/components/react/form/hooks/form';
import type { CheckedState } from '@radix-ui/react-checkbox';

export const ConsentCheckbox = ({ copy }: { copy: string }) => {
  const { state, handleChange } = useFieldContext<CheckedState>();

  return (
    <div className="items-top flex space-x-2">
      <Checkbox
        id="emailMarketing"
        onCheckedChange={handleChange}
        checked={state.value}
      />
      <div className="grid gap-1.5 leading-none">
        <label
          htmlFor="emailMarketing"
          className="text-brand-purple-black text-base font-medium"
        >
          {copy}
        </label>
      </div>
    </div>
  );
};
